import LabsHeader from "./LabsHeader";
import { useEffect, useState, useMemo, useRef } from "react";
import { CircularProgress } from "@mui/material";
import api from "../../../../api/api";
import careiqapi from "../../../../api/careiqapi";
import ToastMessage from "../../../../utils/mui/righttoptoast";
import dayjs from "dayjs";
import { getPracticeId } from "../../../../config/practice";

const LabsWrap = ({ dataId }) => {
  const [labData, setLabData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPanel, setSelectedPanel] = useState("");
  const [dates, setDates] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const patientID = dataId.patientid;
  const practiseid = getPracticeId();
const [userChangedYear, setUserChangedYear] = useState(false);
const [userChangedPanel, setUserChangedPanel] = useState(false);
const intervalRef = useRef(null);
 const handleToastClose = () => {
    setOpenToast(false);
  };
       const [toastSeverity, setToastSeverity] = useState('success');
   const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
const isFirstLoad = useRef(true);
  const fetchLabData = async (x) => {
    if(!x){
        setIsLoading(true);
    }
  
    try {
      const response = await api.get(
        `/v1/${practiseid}/labs/patient/${patientID}/get`
      );

      if (response.status === 200) {
        const { panels, dates: dateList } = response.data;
        setLabData(panels || []);
        setDates(dateList || []);

        // if (panels && panels.length > 0) {
        //   setSelectedPanel(panels[0].panel_name);
        // }

        // if (dateList && dateList.length > 0) {
        //   const uniqueYears = [
        //     ...new Set(dateList.map((d) => new Date(d).getFullYear().toString()))
        //   ];
        //   uniqueYears.sort((a, b) => b - a);
        //   setSelectedYear(uniqueYears[0]);
        // }
        if (isFirstLoad.current) {
  if (panels && panels.length > 0) {
    setSelectedPanel(panels[0].panel_name);
  }

  if (dateList && dateList.length > 0) {
    const uniqueYears = [
      ...new Set(dateList.map((d) =>
        new Date(d).getFullYear().toString()
      )),
    ];
    uniqueYears.sort((a, b) => b - a);
    setSelectedYear(uniqueYears[0]);
  }

  isFirstLoad.current = false;
}

      }
    } catch (error) {
      console.error(
        "Error fetching lab data:",
        error.response ? error.response.data : error
      );
    } finally {
      setIsLoading(false);
    }
  };
// ---------- helpers ----------
const yearHasData = (panel, year) => {
  if (!panel) return false;

  return panel.tests.some(test =>
    test.results.some(
      r => new Date(r.date).getFullYear().toString() === year
    )
  );
};

// ---------- derived values ----------
const selectedPanelData = labData.find(
  (panel) => panel.panel_name === selectedPanel
);

const availableYears = useMemo(() => {
  const unique = [
    ...new Set(dates.map(d => new Date(d).getFullYear().toString()))
  ];
  return unique.sort((a, b) => b - a);
}, [dates]);

useEffect(() => {
  if (!selectedPanelData || !selectedYear) return;

  // -----------------------------
  // USER CLICKED YEAR
  // -----------------------------
  if (userChangedYear) {
    // if current panel has data → nothing
    if (yearHasData(selectedPanelData, selectedYear)) {
      setUserChangedYear(false);
      return;
    }

    // find panel that has data for this year
    const panelWithData = labData.find(panel =>
      yearHasData(panel, selectedYear)
    );

    if (panelWithData) {
      setSelectedPanel(panelWithData.panel_name);
    }

    // IMPORTANT → stop further switching
    setUserChangedYear(false);
    return;
  }

  // -----------------------------
  // USER CLICKED PANEL
  // -----------------------------
  if (userChangedPanel) {
    if (yearHasData(selectedPanelData, selectedYear)) {
      setUserChangedPanel(false);
      return;
    }

    const fallbackYear = availableYears.find(year =>
      yearHasData(selectedPanelData, year)
    );

    if (fallbackYear) {
      setSelectedYear(fallbackYear);
    }

    // IMPORTANT → stop loop
    setUserChangedPanel(false);
  }
}, [
  selectedPanelData,
  selectedYear,
  availableYears,
  userChangedYear,
  userChangedPanel,
  labData
]);



  useEffect(() => {
    fetchLabData();
  }, [patientID]);

  const statusColors = {
    completed: "#4caf50",
    pending: "#e17954",
    notAvailable: "white",
  };
const isOutOfRange = (value, refRange) => {
  if (!value || !refRange) return false;

  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return false;

  const cleaned = refRange.replace(/\s/g, "");

  // Range: 70-110
  if (cleaned.includes("-")) {
    const [min, max] = cleaned.split("-").map(Number);
    if (isNaN(min) || isNaN(max)) return false;
    return numericValue < min || numericValue > max;
  }

  // <=200
  if (cleaned.startsWith("<=")) {
    const max = Number(cleaned.replace("<=", ""));
    return numericValue > max;
  }

  // >=40
  if (cleaned.startsWith(">=")) {
    const min = Number(cleaned.replace(">=", ""));
    return numericValue < min;
  }

  return false;
};

const handlePanelClick = (panelName) => {
  setUserChangedPanel(true);
  setUserChangedYear(false);
  setSelectedPanel(panelName);
};


  const filterResultsByYear = (results) => {
    return results.filter((result) => {
      const resultDate = new Date(result.date);
      return resultDate.getFullYear().toString() === selectedYear;
    });
  };

  // Tests always exist if the panel exists
  const filteredTests = selectedPanelData
    ? selectedPanelData.tests.map((test) => ({
        ...test,
        results: filterResultsByYear(test.results),
      }))
    : [];

  const refreshLabData = async() => {
    try {
      // v2 route: same Athena sync, plus AI extraction of scanned Athena lab
      // docs AND locally uploaded lab PDFs (v1 has neither extraction).
      const response =await careiqapi.get(`/v1/${practiseid}/patient/${dataId.patientid}/labresults`)
      if(response.status==200){
        console.log(response)
     const report = response?.emrlabssyncreport?.[0]
     console.log(report)
    setToastMessage(`${report.newdatacount} lab result(s) synced`);
    setToastSeverity("success");
    setOpenToast(true);


 
      }
    } catch (error) {
      console.log(error)
    }finally{

        fetchLabData();
    }
  
  };

  // Dynamic available years
  // const availableYears = useMemo(() => {
  //   const unique = [...new Set(dates.map((d) => new Date(d).getFullYear().toString()))];
  //   return unique.sort((a, b) => b - a);
  // }, [dates]);

  // *** NEW LOGIC ***
  // Show "No data available" only if there are NO panels at all
  const showNoDataMessage =
    !isLoading && labData.length === 0;
// 🔁 poll every 2 seconds (no mouse tracking)
useEffect(() => {
  // first call immediately
  fetchLabData(true);

  intervalRef.current = setInterval(() => {
    fetchLabData(true); // silent refresh
  }, 2000);

  return () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };
}, [patientID]);


  return (
    <div className="lg:pl-5 pt-2">
   <LabsHeader
  years={availableYears}
  selectedYear={selectedYear}
  setSelectedYear={(year) => {
    setUserChangedYear(true);
    setUserChangedPanel(false);
    setSelectedYear(year);
  }}
  refreshLabData={refreshLabData}
/>

      {isLoading ? (
        <div className="flex justify-center h-[full] w-[90%]">
          <div className="mt-40">
            <CircularProgress />
          </div>
        </div>
      ) : showNoDataMessage ? (
        <div className="flex justify-center items-center h-64 w-[90%] bg-white rounded-md shadow-md border">
          <p className="text-gray-500 text-lg">No lab data available</p>
        </div>
      ) : (
        <div className="flex flex-col lg:w-[90%] w-full items-start justify-start p-4 bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]">
          <div className="grid grid-cols-[220px,1fr] w-full bg-white rounded-md overflow-hidden">
            {/* Panel List */}
            <div className="h-[390px] overflow-y-auto border-r">
              <div className="sticky top-0 z-10 px-3 py-2 text-[12px] font-semibold text-[#6B7280] border-b bg-white">
                Panel
              </div>

              <div className="p-2 flex flex-col gap-3">
                {labData.map((panel, index) => (
                  <button
                    key={index}
                    onClick={() => handlePanelClick(panel.panel_name)}
                    className={`w-[80%] self-center text-center px-3 py-2 text-xs font-semibold shadow-md rounded-md ${
                      selectedPanel === panel.panel_name
                        ? "bg-[#50869A] text-white"
                        : "bg-white text-[#AAAAAA]"
                    }`}
                  >
                    {panel.panel_name}
                  </button>
                ))}
              </div>
            </div>

            {/* Tests Table */}
            {selectedPanelData && (
              <div className="h-[390px] overflow-y-auto min-w-0">
                <table className="min-w-full">
                  <thead className="sticky top-0 z-10 bg-white">
                    <tr className="text-[12px] font-semibold text-[#6B7280] border-b">
                      <th className="text-left py-1 px-3 w-[200px]">
                        Lab Test
                      </th>
                      {/* If no results for this year, still render one empty column */}
                      {(filteredTests[0]?.results.length > 0
                        ? filteredTests[0].results
                        : [null]
                      ).map((res, i) => (
                        <th key={i} className="text-left py-2 px-3 w-[160px]">
                          {dayjs(res ? res.date : selectedYear).format("MM-DD-YYYY")}
                        </th>
                      ))}
                      <th className="text-left py-2 px-3 w-[160px]">Ref.range</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredTests.map((test, idx) => (
                      <tr key={idx} className="border-b last:border-0">
                        <td className="px-3 text-left text-[13px] text-[#111827]">
                          {test.testname}
                        </td>

                        {(test.results.length > 0 ? test.results : [null]).map(
                          (res, i) => (
                            <td key={i} className="px-3 text-[14px] text-[#111827]">
                              {res ? (
                                <div className="flex items-center gap-2">
                                  <div
                                    className="w-2.5 h-2.5 mr-2 rounded-full"
                                     style={{
    backgroundColor: isOutOfRange(
      res.value,
      test.refrange || res.refrange
    )
      ? "#EF4444" // 🔴 red for out-of-range
      : statusColors[res.status] || "#ccc",
  }}
                                  />
                                  {res.value}
                                </div>
                              ) : (
                                <span className="text-gray-400">–</span>
                              )}
                            </td>
                          )
                        )}

                        <td className="px-3 text-left text-[12px] text-[#8A8D90]">
                          {test.refrange || test.results[0]?.refrange || ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Show a subtle note if no results for the selected year */}
            {!availableYears.some(year => yearHasData(selectedPanelData, year)) && (
  <div className="p-4 text-gray-500 text-sm">
    No results found.
  </div>
)}

              </div>
            )}
          </div>
        </div>
      )}


                      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default LabsWrap;
